module.exports = __webpack_public_path__ + "img/emotional.5327a767.svg";